import { createSelector } from 'reselect';
import CalendarCopy from '../copy/calendar';
import { ADD_MEETING, ADD_MESSAGE } from '../constants/actions';

const getCurrentDay = state => state.activeGame.currentDay;

const getCurrentMessages = state => state.activeGame.currentMessages;
const getMessagesIndexes = state => state.activeGame.messagesIndexes;

const getCurrentMeetings = state => state.activeGame.currentMeetings;
const getMeetingsIndexes = state => state.activeGame.meetingsIndexes;

export const getCalendar = (party, difficulty) => {
    const copy = CalendarCopy[difficulty];
    return copy.day.map(day => {
        return {
            day: parseInt(day.name),
            call: day.call.filter(phoneCall => phoneCall.party === party),
        };
    });
};

export const addNewMessageOrMeeting = createSelector(
    [
        getCurrentDay,
        getCurrentMessages,
        getMessagesIndexes,
        getCurrentMeetings,
        getMeetingsIndexes,
    ],
    (
        currentDay,
        currentMessages,
        messagesIndexes,
        currentMeetings,
        meetingsIndexes,
    ) => {
        const coinFlip = Math.random();

        if (meetingsIndexes.length === 0) {
            return {
                type: ADD_MESSAGE,
                message: messagesIndexes[0],
            };
        } else if (messagesIndexes.length === 0) {
            return {
                type: ADD_MEETING,
                meeting: meetingsIndexes[0],
            };
        }

        if (currentDay >= 1 && coinFlip < 0.5) {
            return {
                type: ADD_MESSAGE,
                message: messagesIndexes[0],
            };
        } else {
            return {
                type: ADD_MEETING,
                meeting: meetingsIndexes[0],
            };
        }
    },
);
